import React from 'react';
import { Item2, SpinnerContainer, SpinnerItem } from './Spinner.styled';

const Spinner = () => {
  return (
    <SpinnerContainer>
      <SpinnerItem />
      <Item2 />
    </SpinnerContainer>
  );
};

export default Spinner;
